import * as React from "react";
import { FeedItemReceiveGold } from "../../../server/feed/buildfeed";
import { FeedPanel } from "../DesignSystem/formatting/FeedComponents";
import { Coins } from "./Coins";

export const FeedItemGoldReasons = ({
  item,
}: {
  item: FeedItemReceiveGold;
}) => {
  let reasons = [...item.reasons];

  if (reasons.length > 1) {
    reasons.push({
      reason: "Total",
      amount: String(item.amount),
      created: new Date(),
    });
  }

  return (
    <FeedPanel title={<>Gold Earned This Week</>}>
      {item.reasons.map(({ reason, amount }) => (
        <div key={reason}>
          <span className="inline-block w-[100px]">
            <Coins spaced amount={Number(amount)} />
          </span>{" "}
          {reason}
        </div>
      ))}
    </FeedPanel>
  );
};
